import { getViagemById, deleteViagem } from "@spark/services";
import { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { notification } from '@spark/ui-components/utils/notification';

export const useViagemDetalhes = () => {
  const { id } = useParams();
  const history = useHistory();
  const [viagem, setViagem] = useState(null);
  const [loading, setLoading] = useState(true);
  const inFlightRef = useRef(false);
  const didInitialLoadRef = useRef(false);
  const [deleting, setDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isMountedRef = useRef(true);

  // Cleanup quando componente é desmontado
  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Carregar dados da viagem
  const loadViagem = useCallback(async () => {
    if (!id || !isMountedRef.current) return;
    console.log('🔄 Carregando viagem com ID:', id);

    try {
      const response = await getViagemById(id);
      const viagemData = response?.data?.data || response;
      console.log('📥 Resposta da API:', viagemData);

      if (isMountedRef.current) {
        if (viagemData) {
          console.log('✅ Viagem carregada:', viagemData);
          setViagem(viagemData);
        } else {
          console.log('⚠️ Resposta sem dados:', viagemData);
        }
      }
    } catch (error) {
      console.error('❌ Erro ao carregar viagem:', error);
      // Erro tratado automaticamente pelo interceptor global do axios
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }, [id]);

  // Carregar dados iniciais (single effect, reduz chamadas duplicadas)
  useEffect(() => {
    if (!id || !isMountedRef.current) return;
    if (didInitialLoadRef.current) return;
    didInitialLoadRef.current = true;

    (async () => {
      try {
        setLoading(true);
        await loadViagem();
      } finally {
        if (isMountedRef.current) setLoading(false);
      }
    })();
  }, [id, loadViagem]);

  // Handlers de navegação
  const handleEditar = useCallback(() => {
    history.push(`/pages/viagens/editar/${id}`);
  }, [history, id]);

  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleExcluir = useCallback(() => {
    setShowDeleteModal(true);
  }, []);

  // Confirmar exclusão
  const confirmDelete = useCallback(async () => {
    if (!isMountedRef.current) return;
    setDeleting(true);

    try {
      await deleteViagem(id);

      if (isMountedRef.current) {
        notification.success('Viagem excluída com sucesso');
        setShowDeleteModal(false);
        history.push('/pages/viagens');
      }
    } catch (error) {
      console.error('❌ Erro ao excluir viagem:', error);
      // Erro tratado automaticamente pelo interceptor global do axios
    } finally {
      if (isMountedRef.current) {
        setDeleting(false);
      }
    }
  }, [id, history]);

  // Callback após sucesso em alguma operação
  const handleSuccess = useCallback(() => {
    loadViagem();
  }, [loadViagem]);

  return {
    viagem,
    loading,
    deleting,
    showDeleteModal,
    setShowDeleteModal,
    handleEditar,
    handleVoltar,
    handleExcluir,
    confirmDelete,
    handleSuccess
  };
};
